// RichTextEditor.js
import React, { useRef } from "react";
import "./RichTextEditor.scss";
import { Editor } from "@tinymce/tinymce-react";
import { createRoot } from "react-dom/client";

export default class RichTextEditor {
  static get toolbox() {
    return {
      title: "RichTextEditor",
      icon: `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 15v4H5v-4h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 18.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 5v4H5V5h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 8.5c-.82 0-1.5-.67-1.5-1.5S6.18 5.5 7 5.5s1.5.68 1.5 1.5S7.83 8.5 7 8.5z"/></svg>`,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ api, data, config }) {
    this.api = api;
    this.config = config;
    this.data = { value: data?.value || "" };
    this._root = null;
  }

  render() {
    const rootNode = document.createElement("div");
    rootNode.classList.add("editortinymce");

    const EditorComponent = () => {
      const editorRef = useRef(null);

      const handleEditorChange = (newContent) => {
        this.data.value = newContent;
      };

      const isEditable = !this.data.value || (this.config.context?.isAdmin && !this.config.context?.preview);

      return (
        <Editor
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          initialValue={this.data.value}
          onEditorChange={handleEditorChange}
          onInit={(evt, editor) => (editorRef.current = editor)}
          disabled={!isEditable}
          init={{
            license_key: "gpl",
            minHeight: 400,
            menubar: false,
            branding: false,
            statusbar: false,
            readonly: !isEditable,
            plugins: [
              "code", "help", "lists", "media", "table", "anchor",
              "charmap", "preview", "advlist", "wordcount", "fullscreen",
              "autoresize", "visualblocks", "searchreplace", "insertdatetime"
            ],
            toolbar: isEditable
              ? "undo redo | blocks | bold italic underline forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help"
              : false,
            content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      );
    };

    if (this._root) this._root.unmount();
    this._root = createRoot(rootNode);
    this._root.render(<EditorComponent />);

    return rootNode;
  }

  save() {
    return { value: this.data.value };
  }

  destroy() {
    if (this._root) {
      this._root.unmount();
      this._root = null;
    }
  }
}